The upper limit of advertisement brandings to return from the end of the list.

Excess advertisement brandings will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
